<template>
  <div class="cash-sources-stat">
    <div class="stat-menu-abc">
      <v-container fluid>
        <stat-top-filter
          :filial-default="[globalFilialId]"
          last-month
          multiple-filial-select
          @applyFilter="applyFilter"
        />

        <filials-indicators-list
          v-if="Object.keys(indicators).length"
          class="mb-5"
          :indicators="indicators"
          :loading="isLoading"
        />

        <chart-container
          class="mb-5"
          :loading="isLoading"
          :no-data="!statistics.length"
        >
          <template #chart>
            <orders-chart title="График по заказам" :items="statistics" :time-unit="chartTimeUnit" />
          </template>
        </chart-container>

        <chart-container
          class="mb-5"
          :loading="isLoading"
          :no-data="!timeLoadStatistics.length"
        >
          <template #chart>
            <orders-bar-chart
              title="Нагрузка по времени"
              :items="timeLoadStatistics"
            />
          </template>
        </chart-container>

        <proportion-charts-view ref="proportionChartsView" />
      </v-container>
    </div>
  </div>
</template>

<script>
  import StatTopFilter from '@/components/stat/StatTopFilter.vue'
  import { mapGetters } from 'vuex'
  import SnackbarMessage from '@/mixins/snackbar-message'
  import permissions from '@/mixins/permissions'
  import FilialsIndicatorsList from '@/components/stat/call-center/FilialsIndicatorsList.vue'
  import OrdersTimeLoadChart from '@/components/stat/call-center/OrdersTimeLoadChart.vue'
  import ProportionChartsView from '@/components/stat/call-center/ProportionChartsView.vue'
  import ChartContainer from '@/components/stat/ChartContainer.vue'
  import ordersStatisticsApi from '@/api/statistics/call-center/orders'
  import { differenceInMonths, differenceInYears } from 'date-fns'
  import OrdersChart from '@/components/stat/call-center/OrdersChart.vue'
  import filialsStatisticsApi from '@/api/statistics/call-center/filials'

  export default {
    name: 'OrdersStatistics',
    components: {
      OrdersChart,
      ChartContainer,
      ProportionChartsView,
      OrdersBarChart: OrdersTimeLoadChart,
      StatTopFilter,
      FilialsIndicatorsList,
    },
    mixins: [permissions, SnackbarMessage],
    data () {
      return {
        indicators: {},
        isLoading: false,
        startDate: null,
        endDate: null,
        statistics: [],
        timeLoadStatistics: [],
        chartTimeUnit: 'day',
      }
    },
    computed: {
      ...mapGetters({
        globalFilialId: 'branches/getGlobalFilialId',
      }),
    },
    methods: {
      applyFilter (filter) {
        const payload = {
          from: filter.from,
          to: filter.to,
          filialIds: filter.filialId,
          filialPreset: filter.filialPreset,
        }

        this.fetchStatistics(payload)
      },
      async fetchStatistics (data) {
        if (this.$refs.proportionChartsView) {
          this.$refs.proportionChartsView.fetchStatistics(data)
        }

        this.isLoading = true
        this.statisticData = []

        Promise.all([
          ordersStatisticsApi.fetchOrdersStatistics(data),
          ordersStatisticsApi.fetchOrdersTimeLoadStatistics(data),
          filialsStatisticsApi.fetchFilialsIndicators(data),
        ])
          .then((responses) => {
            this.chartTimeUnit = this.calcChartTimeUnit(data.from, data.to)
            this.statistics = responses[0].items
            this.timeLoadStatistics = responses[1].items
            this.indicators = responses[2].data
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.isLoading = false
          })
      },
      calcChartTimeUnit (from, to) {
        if (!from || !to) {
          return 'day'
        }

        const startDate = new Date(from)
        const endDate = new Date(to)

        if (Math.abs(differenceInYears(endDate, startDate)) >= 1) {
          return 'month'
        }

        if (Math.abs(differenceInMonths(endDate, startDate)) >= 2) {
          return 'week'
        }

        return 'day'
      },
    },
  }
</script>

<style lang="less" scoped>
@import 'src/assets/styles/statistic.less';
</style>
